import {Component, Input, OnInit} from '@angular/core';
import {UserRightGroupUi} from '../../../interfaces/userRightGroupUi';

@Component({
  selector: 'qm-rights-of-group',
  templateUrl: './rights-of-group.component.html',
  styleUrls: ['./rights-of-group.component.css']
})
export class RightsOfGroupComponent implements OnInit {

  @Input() groupId: number;
  @Input() userRightsGroupUis: UserRightGroupUi[];

  constructor() {
  }

  async ngOnInit(): Promise<void> {
  }

}

